import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import endpoints, { apiRequest } from '../../endpoints';
import { useSelector, useDispatch } from 'react-redux'
import TagsTable from './tables/TagsTable'
import EditTagModal from './modals/EditTagModal'
import Button from '@mui/material/Button';
import AddBoxIcon from '@mui/icons-material/AddBoxRounded';
import Confirmation from './modals/Confirmation';
import Warning from './modals/Warning';
import withAlert from '../../hoc/withAlerts'
import { setHeader } from '../../redux/headerSlice'
import Grow from '@mui/material/Grow';

function Tags(props) {
    const [list, setList] = useState(null)
    const [dialogData, setDialogData] = useState(null)
    const [deleteItem, setDeleteItem] = useState()
    const [warningText, setWarningText] = useState()

    const dispatch = useDispatch()
    
    const tagsUpdateHandler = () => {
        getList()
    }

    useEffect(() => {
        getList();
        if (!props.embedded) {
            dispatch(setHeader({
                title: 'Tags'
            }))
        }

        window.addEventListener('TAGS_UPDATED', tagsUpdateHandler)
        return () => {
            window.removeEventListener('TAGS_UPDATED', tagsUpdateHandler)
        }
    }, []);

    const token = useSelector((state) => state.auth.token)

    const getList = async () => {
        try {
            const res = await apiRequest('get', endpoints.tags, {
                token: token,
            })
            setList(res.data.items)
        } catch (e) {
            setList([])
            showAlertError('Unknown Error - get list')
        }
    }

    const saveHandle = (data) => {
        setDialogData(null)
        getList()
    }
    
    const deleteHandle = async (response) => {
        if (response) {
            try {
                const res = await apiRequest('delete', endpoints.tags_delete, {
                    token: token,
                    id: deleteItem.id,
                })
                await getList()
                showAlertSuccess('Item deleted successfully!')
            } catch (e) {
                showAlertError('Unknown Error - delete Item')
            }
        }
        setDeleteItem(null)
    }

    const showAlertError = (message) => {
        props.showAlert(message, 'error')
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }

    return (
        <Grow in={list ? true : false}>
            <Stack sx={{ maxWidth: 1200, margin: 'auto', overflow: 'hidden', marginTop: '8px' }}>
                <Stack spacing={2} direction="row" sx={{pb: 2}} justifyContent="space-between">
                    <Stack sx={{ flexGrow: 1 }}/>
                    <FormControl variant="standard" sx={{ paddingTop:1.5 }}>
                        <Button variant="contained" startIcon={<AddBoxIcon />} onClick={() => {setDialogData({})}}>
                            Add Tag
                        </Button>
                    </FormControl>
                </Stack>
                <Stack>
                    <TagsTable items={list}
                        btnEditHandle={(item) => {setDialogData(item)}}
                        btnDeleteHandle={(item) => {setDeleteItem(item)}}
                    />
                </Stack>
                <EditTagModal 
                    dialogData={dialogData}
                    onClose={ () => {setDialogData(null)} }
                    onSave={saveHandle}
                />
                <Confirmation data={deleteItem} onResponse={deleteHandle} />
                <Warning text={warningText} onClose={() => {setWarningText(null)}} />
            </Stack>
        </Grow>
    );
}

export default withAlert(Tags)